/* Campnetic: verhindert, dass ein Klick auf das KI-Badge Dawns Lightbox oder den Kartenlink auslöst. */
(function () {
  var ereignisse = ['pointerdown', 'pointerup', 'mousedown', 'mouseup', 'touchstart', 'touchend', 'click', 'dblclick'];

  function schutz(ereignis) {
    var ziel = ereignis.target;
    if (!ziel || ziel.nodeType !== 1 || !ziel.closest) return;
    if (ziel.closest('[data-cn-ki]')) ereignis.stopPropagation();
  }

  for (var i = 0; i < ereignisse.length; i++) {
    document.addEventListener(ereignisse[i], schutz, true);
  }
})();
